// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pluginItem__e78 {
  .pluginSource__a2e {
    color: var(--ring-secondary-color);
  }

  .pluginName__b88 + .pluginSource__a2e {
    margin-left: var(--ring-unit);
  }

  .pluginId__a65 {
    font-size: var(--ring-font-size-smaller);
    line-height: var(--ring-line-height-lowest);

    :first-child {
      color: var(--ring-secondary-color);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/single-plugin-rule/common/plugin-selector/plugin-selector-item/plugin-selector-item.css"],"names":[],"mappings":"AAAA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,wCAAwC;IACxC,2CAA2C;;IAE3C;MACE,kCAAkC;IACpC;EACF;AACF","sourcesContent":[".pluginItem {\n  .pluginSource {\n    color: var(--ring-secondary-color);\n  }\n\n  .pluginName + .pluginSource {\n    margin-left: var(--ring-unit);\n  }\n\n  .pluginId {\n    font-size: var(--ring-font-size-smaller);\n    line-height: var(--ring-line-height-lowest);\n\n    :first-child {\n      color: var(--ring-secondary-color);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pluginItem": `pluginItem__e78`,
	"pluginSource": `pluginSource__a2e`,
	"pluginName": `pluginName__b88`,
	"pluginId": `pluginId__a65`
};
export default ___CSS_LOADER_EXPORT___;
